/** Страница приложения «Любить по-russки» в RuStore — единый адрес для всех кнопок «Скачать». */
export const RUSTORE_URL = "https://www.rustore.ru/catalog/app/ru.forruss.app";

/**
 * Официальный значок RuStore «logo-monochrome-light» (rustore.ru/help/icons),
 * файл без правок: белый на прозрачном, с белой рамкой — под тёмный подвал.
 * Лежит в public/Brand.
 */
export function RuStoreBadge({className}: {className?: string}) {
    return (
        <a
            href={RUSTORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className={className}
            aria-label="RuStore"
        >
            <img src="/Brand/RuStoreBadge.svg" alt="" width={111} height={40}/>
        </a>
    );
}
